<template>
    <vx-table-row>
        <vx-table-row-title>
            <vx-badge color="slate" size="xs" class="font-mono" data-test="brand-id">
                {{ props.modelValue.brand_id }}
            </vx-badge>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Source: </template>
            <span data-test="source">{{ sourceLabels[props.modelValue.source] }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="display-name">
            <template v-slot:label> Name: </template>
            <span class="text-sm font-bold line-clamp-2" :title="props.modelValue.display_name ?? undefined">
                {{ props.modelValue.display_name || '—' }}
            </span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> EIN: </template>
            <span class="font-mono" data-test="universal-ein">{{ props.modelValue.universal_ein ?? '—' }}</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Entity Type: </template>
            <span data-test="entity-type">{{
                props.modelValue.entity_type ? entityTypeLabels[props.modelValue.entity_type] : '—'
            }}</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Verification: </template>
            <span :class="{ 'font-bold': props.modelValue.verified }" data-test="verification">
                {{ verifiedLabel(props.modelValue.verified) }}
            </span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Trust Score: </template>
            <span data-test="trust-score">{{ props.modelValue.vetting_score ?? '—' }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="campaigns-count">
            <template v-slot:label> Campaigns: </template>
            {{ props.modelValue.campaigns_count }}
        </vx-table-row-item>

        <vx-table-row-item data-test="phone-numbers-count">
            <template v-slot:label> Numbers: </template>
            {{ props.modelValue.phone_numbers_count }}
        </vx-table-row-item>

        <vx-table-row-item data-test="synced-at">
            <template v-slot:label> Synced: </template>
            <span :key="syncedAtKey" :title="shortDateTime(props.modelValue.synced_at)">
                {{ fromNow(props.modelValue.synced_at) }}
            </span>
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-button :href="campaignsHref" size="sm" data-test="view" outline color="muted">
                View <font-awesome-icon widthAuto :icon="faEye" />
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxBadge,
    VxButton,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import { computed } from 'vue';
import { entityTypeLabels, sourceLabels, verifiedLabel } from '~/components/kiosk/kiosk-ten-dlc/tenDlcLabels';
import type { TcrBrand } from '~/services/adminTenDlcClient.types';
import { fromNow, shortDateTime } from '~/utils/date';
import { stringifyQueryString } from '~/utils/string';

const props = defineProps<{
    modelValue: TcrBrand;
}>();

const syncedAtKey = useInterval(60000);

const campaignsHref = computed(
    () => `/kiosk/ten-dlc/campaigns?${stringifyQueryString({ brand_id: props.modelValue.brand_id })}`
);
</script>
